module.exports = __webpack_public_path__ + "img/97.801bc92e.gif";